module.exports = __webpack_public_path__ + "static/moon-lg-4e57885235e5418129b2f7274342d2b1.svg";